<div class="banner-with-button">
  <sd-generic-link [url]="banner.link" (click)="onBannerClick(banner)">
    <img [ngSrc]="banner.url" [alt]="banner.altText" fill />
  </sd-generic-link>
  <sd-generic-link [url]="banner.link" (click)="onBannerClick(banner)">
    <button
      sdNavButton
      class="button-nav-link"
      [icon]="iconTypes.ARROW_NEXT"
      size="{{ isDesktop ? 'l' : isTablet ? 'm' : 's' }}"
    ></button>
  </sd-generic-link>
</div>
